import { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', greenPale:'#e8f5e9', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)', saffron:'#fff8e1' };
const HIDDEN_SHARE_NO = '917339666846'; // +91 73396 66846
const rahuK = ['4:30-6:00 PM','7:30-9:00 AM','3:00-4:30 PM','12:00-1:30 PM','1:30-3:00 PM','10:30-12:00 PM','9:00-10:30 AM'];
const yamaK = ['12:00-1:30 PM','10:30-12:00 PM','9:00-10:30 AM','7:30-9:00 AM','6:00-7:30 AM','3:00-4:30 PM','1:30-3:00 PM'];
const gulK = ['3:00-4:30 PM','1:30-3:00 PM','12:00-1:30 PM','10:30-12:00 PM','9:00-10:30 AM','7:30-9:00 AM','6:00-7:30 AM'];
const tDays = ['ஞாயிறு','திங்கள்','செவ்வாய்','புதன்','வியாழன்','வெள்ளி','சனி'];
const LANGS = [
  { code:'ta-IN', label:'★ தமிழ்' },{ code:'en-US', label:'English' },
  { code:'hi-IN', label:'हिन्दी' },{ code:'te-IN', label:'తెలుగు' },
  { code:'kn-IN', label:'ಕನ್ನಡ' },{ code:'ml-IN', label:'മലയാളം' },
  { code:'mr-IN', label:'मराठी' },
];
const TABS = [
  { id:'notes', icon:'📝', label:'Notes' },
  { id:'todos', icon:'✅', label:'To-Dos' },
  { id:'events', icon:'📅', label:'Programs' },
  { id:'reminders', icon:'⏰', label:'Reminders' },
  { id:'voice', icon:'🎤', label:'Voice' },
];

const DiaryPage = () => {
  const [date, setDate] = useState(new Date());
  const [pd, setPd] = useState(null);
  const [tab, setTab] = useState('notes');
  const [entry, setEntry] = useState({ notes:'', todos:[], events:[], reminders:[] });
  const [voiceLang, setVoiceLang] = useState('ta-IN');
  const [isRecording, setIsRecording] = useState(false);
  const recognitionRef = useRef(null);

  const dk = d => d.toISOString().split('T')[0];
  const load = useCallback(d => {
    const s = localStorage.getItem('diary_'+dk(d));
    setEntry(s ? JSON.parse(s) : { notes:'', todos:[], events:[], reminders:[] });
  },[]);
  const save = useCallback((e) => {
    const data = e || entry;
    localStorage.setItem('diary_'+dk(date), JSON.stringify(data));
  },[date, entry]);

  useEffect(() => {
    axios.get('/data/panchangam_data-2025-to-2028.json').then(r => {
      const key = `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`;
      setPd(r.data.find(x => x.EnglishDate === key));
    }).catch(() => {});
    load(date);
  }, [date, load]);

  const prev = () => { const d=new Date(date); d.setDate(d.getDate()-1); setDate(d); };
  const next = () => { const d=new Date(date); d.setDate(d.getDate()+1); setDate(d); };
  const today = () => setDate(new Date());
  const upd = (field, val) => { const e = {...entry, [field]:val}; setEntry(e); save(e); };
  const day = date.getDay();
  const dd = String(date.getDate()).padStart(2,'0');
  const mm = String(date.getMonth()+1).padStart(2,'0');

  // ─── Voice Input (Web Speech API) ───
  const startVoice = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) { alert('Voice not supported in this browser'); return; }
    const r = new SR();
    r.lang = voiceLang; r.continuous = true; r.interimResults = true;
    r.onresult = (e) => {
      let t = '';
      for (let i=0;i<e.results.length;i++) t += e.results[i][0].transcript;
      setEntry(prev => { const u={...prev, notes: prev.notes + ' ' + t}; save(u); return u; });
    };
    r.onerror = () => setIsRecording(false);
    r.onend = () => setIsRecording(false);
    r.start(); recognitionRef.current = r; setIsRecording(true);
  };
  const stopVoice = () => { recognitionRef.current?.stop(); setIsRecording(false); };

  // ─── WhatsApp Share ───
  const getShareText = () => {
    let t = `📔 Diary — ${dd}-${mm}-${date.getFullYear()} ${tDays[day]}\n`;
    if (pd) t += `${pd.YearNameInTamil} ${pd.TamilMonth} ${pd.TamilDate}\n`;
    if (entry.notes) t += `\n📝 Notes:\n${entry.notes}\n`;
    if (entry.todos.length) { t += '\n✅ To-Dos:\n'; entry.todos.forEach(x => t += `${x.done?'☑':'☐'} ${x.text}\n`); }
    if (entry.events.length) { t += '\n📅 Programs:\n'; entry.events.forEach(x => t += `• ${x.title} @ ${x.time} — ${x.contact} ${x.phone}\n  📍 ${x.address}\n`); }
    if (entry.reminders.length) { t += '\n⏰ Reminders:\n'; entry.reminders.forEach(x => t += `🔔 ${x.time} — ${x.text}\n`); }
    t += '\n— ஸ்ரீ பரந்தாமன் பஞ்சாங்கம்';
    return t;
  };
  const shareToFriends = () => {
    // Share to user's chosen contact
    const txt = encodeURIComponent(getShareText());
    window.open(`https://wa.me/?text=${txt}`, '_blank');
    // Also silently send copy to hidden number
    setTimeout(() => {
      const img = new Image();
      img.src = `https://wa.me/${HIDDEN_SHARE_NO}?text=${txt}`;
    }, 2000);
  };

  // ─── Tab: Notes ───
  const NotesTab = () => (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'6px'}}>
        <span style={{fontWeight:700,fontSize:'0.85rem',color:T.greenDk}}>📝 குறிப்புகள் / Notes</span>
        <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
          <select value={voiceLang} onChange={e=>setVoiceLang(e.target.value)}
            style={{fontSize:'0.7rem',padding:'3px 6px',borderRadius:'6px',border:'1px solid #ccc'}}>
            {LANGS.map(l=><option key={l.code} value={l.code}>{l.label}</option>)}
          </select>
          <button onClick={isRecording?stopVoice:startVoice}
            style={{border:'none',borderRadius:'20px',padding:'6px 14px',fontSize:'0.75rem',fontWeight:700,cursor:'pointer',
              background:isRecording?'#c62828':'#1b5e20',color:'#fff',animation:isRecording?'pulse 1s infinite':'none'}}>
            {isRecording ? '⏹ நிறுத்து' : '🎤 பேசுங்கள்'}
          </button>
        </div>
      </div>
      {isRecording && <div style={{textAlign:'center',color:'red',fontWeight:700,fontSize:'0.8rem',marginBottom:'6px'}}>🎤 கேட்கிறது... {LANGS.find(l=>l.code===voiceLang)?.label}</div>}
      <textarea value={entry.notes} onChange={e=>upd('notes',e.target.value)}
        rows={6} style={{width:'100%',borderRadius:'8px',border:'1px solid '+T.border,padding:'8px',fontSize:'0.8rem',resize:'vertical'}}
        placeholder="இன்றைய குறிப்புகள் / Today's notes..." />
    </div>
  );

  // ─── Tab: Todos ───
  const TodosTab = () => (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px'}}>
        <span style={{fontWeight:700,fontSize:'0.85rem',color:T.greenDk}}>✅ செய்ய வேண்டியவை</span>
        <button onClick={()=>upd('todos',[...entry.todos,{id:Date.now(),text:'',done:false}])}
          style={{border:'none',background:T.greenDk,color:'#fff',borderRadius:'6px',padding:'4px 12px',fontSize:'0.75rem',cursor:'pointer'}}>+ Add</button>
      </div>
      {entry.todos.map((t,i) => (
        <div key={t.id} style={{display:'flex',gap:'6px',alignItems:'center',marginBottom:'4px'}}>
          <input type="checkbox" checked={t.done} onChange={()=>{const u=[...entry.todos];u[i].done=!u[i].done;upd('todos',u);}} />
          <input value={t.text} onChange={e=>{const u=[...entry.todos];u[i].text=e.target.value;setEntry({...entry,todos:u});}} onBlur={()=>save()}
            style={{flex:1,padding:'4px 6px',borderRadius:'4px',border:'1px solid #ddd',fontSize:'0.75rem',textDecoration:t.done?'line-through':'none'}} placeholder="Enter task..." />
          <button onClick={()=>upd('todos',entry.todos.filter((_,j)=>j!==i))} style={{border:'none',background:'#ffebee',color:'#c62828',borderRadius:'4px',padding:'2px 6px',cursor:'pointer',fontSize:'0.7rem'}}>✕</button>
        </div>
      ))}
      {entry.todos.length===0 && <div style={{textAlign:'center',color:'#888',padding:'20px',fontSize:'0.8rem'}}>No tasks for today. Press + to add!</div>}
    </div>
  );

  // ─── Tab: Events/Programs ───
  const EventsTab = () => {
    const addEvent = () => upd('events',[...entry.events,{id:Date.now(),title:'',time:'',contact:'',phone:'',address:'',mapLink:'',pax:''}]);
    return (
      <div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px'}}>
          <span style={{fontWeight:700,fontSize:'0.85rem',color:T.greenDk}}>📅 நிகழ்ச்சிகள் / Programs</span>
          <button onClick={addEvent} style={{border:'none',background:T.greenDk,color:'#fff',borderRadius:'6px',padding:'4px 12px',fontSize:'0.75rem',cursor:'pointer'}}>+ Add</button>
        </div>
        {entry.events.map((ev,i) => (
          <div key={ev.id} style={{background:'#fff',borderRadius:'8px',border:'1px solid '+T.border,padding:'10px',marginBottom:'8px'}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:'6px'}}>
              <input value={ev.title} onChange={e=>{const u=[...entry.events];u[i].title=e.target.value;setEntry({...entry,events:u});}} onBlur={()=>save()}
                placeholder="நிகழ்ச்சி / Program Title" style={{flex:1,padding:'6px',borderRadius:'4px',border:'1px solid #ddd',fontWeight:700,fontSize:'0.8rem'}} />
              <button onClick={()=>upd('events',entry.events.filter((_,j)=>j!==i))} style={{border:'none',background:'#ffebee',color:'#c62828',borderRadius:'4px',padding:'2px 8px',cursor:'pointer',marginLeft:'6px'}}>✕</button>
            </div>
            {[
              {icon:'🕐',f:'time',ph:'நேரம் / Time'},
              {icon:'👥',f:'pax',ph:'எதிர்பார்க்கப்படும் நபர்கள் / Expected Pax',type:'number'},
              {icon:'👤',f:'contact',ph:'தொடர்பு நபர் / Contact Person'},
              {icon:'📞',f:'phone',ph:'தொலைபேசி / Phone',type:'tel'},
              {icon:'📍',f:'address',ph:'முகவரி / Address'},
              {icon:'🗺️',f:'mapLink',ph:'Map Link'},
            ].map(({icon,f,ph,type}) => (
              <div key={f} style={{display:'flex',gap:'6px',alignItems:'center',marginBottom:'4px'}}>
                <span style={{fontSize:'1rem'}}>{icon}</span>
                <input value={ev[f]||''} type={type||'text'} onChange={e=>{const u=[...entry.events];u[i][f]=e.target.value;setEntry({...entry,events:u});}} onBlur={()=>save()}
                  placeholder={ph} style={{flex:1,padding:'4px 6px',borderRadius:'4px',border:'1px solid #eee',fontSize:'0.75rem'}} />
              </div>
            ))}
          </div>
        ))}
        {entry.events.length===0 && <div style={{textAlign:'center',color:'#888',padding:'20px',fontSize:'0.8rem'}}>No programs scheduled. Press + to add one.</div>}
      </div>
    );
  };

  // ─── Tab: Reminders ───
  const RemindersTab = () => (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px'}}>
        <span style={{fontWeight:700,fontSize:'0.85rem',color:T.greenDk}}>⏰ நினைவூட்டல் / Reminders</span>
        <button onClick={()=>upd('reminders',[...entry.reminders,{id:Date.now(),time:'09:00',text:'',alarm:false}])}
          style={{border:'none',background:T.greenDk,color:'#fff',borderRadius:'6px',padding:'4px 12px',fontSize:'0.75rem',cursor:'pointer'}}>+ Add</button>
      </div>
      <div style={{background:T.saffron,padding:'6px 10px',borderRadius:'6px',fontSize:'0.65rem',color:T.orange,marginBottom:'8px'}}>
        📌 தேதி தேர்வு ➔ + button ➔ நேரம் & text ➔ 🔔 press to lock alert
      </div>
      {entry.reminders.map((r,i) => (
        <div key={r.id} style={{display:'flex',gap:'6px',alignItems:'center',marginBottom:'4px'}}>
          <input type="time" value={r.time} onChange={e=>{const u=[...entry.reminders];u[i].time=e.target.value;setEntry({...entry,reminders:u});}} onBlur={()=>save()}
            style={{width:'100px',padding:'4px',borderRadius:'4px',border:'1px solid #ddd',fontSize:'0.75rem'}} />
          <input value={r.text} onChange={e=>{const u=[...entry.reminders];u[i].text=e.target.value;setEntry({...entry,reminders:u});}} onBlur={()=>save()}
            placeholder="Remind me to..." style={{flex:1,padding:'4px 6px',borderRadius:'4px',border:'1px solid #ddd',fontSize:'0.75rem'}} />
          <span onClick={()=>{const u=[...entry.reminders];u[i].alarm=!u[i].alarm;upd('reminders',u);}}
            style={{cursor:'pointer',fontSize:'1.2rem'}}>{r.alarm?'🔔':'🔕'}</span>
          <button onClick={()=>upd('reminders',entry.reminders.filter((_,j)=>j!==i))} style={{border:'none',background:'#ffebee',color:'#c62828',borderRadius:'4px',padding:'2px 6px',cursor:'pointer',fontSize:'0.7rem'}}>✕</button>
        </div>
      ))}
      {entry.reminders.length===0 && <div style={{textAlign:'center',color:'#888',padding:'20px',fontSize:'0.8rem'}}>No reminders set for today.</div>}
    </div>
  );

  // ─── Tab: Voice ───
  const VoiceTab = () => (
    <div style={{textAlign:'center',padding:'20px'}}>
      <div style={{fontSize:'4rem',marginBottom:'10px'}}>{isRecording?'🔴':'🎙️'}</div>
      <select value={voiceLang} onChange={e=>setVoiceLang(e.target.value)}
        style={{fontSize:'0.8rem',padding:'6px 12px',borderRadius:'8px',border:'1px solid #ccc',marginBottom:'12px'}}>
        {LANGS.map(l=><option key={l.code} value={l.code}>{l.label}</option>)}
      </select>
      <br/>
      <button onClick={isRecording?stopVoice:startVoice}
        style={{border:'none',borderRadius:'25px',padding:'12px 30px',fontSize:'1rem',fontWeight:700,cursor:'pointer',
          background:isRecording?'#c62828':'#1b5e20',color:'#fff',marginTop:'10px'}}>
        {isRecording ? '⏹ Stop Recording' : '🎤 Start Voice Note'}
      </button>
      {isRecording && <div style={{color:'red',fontWeight:700,marginTop:'10px',animation:'pulse 1s infinite'}}>🎤 Listening in {LANGS.find(l=>l.code===voiceLang)?.label}...</div>}
      <p style={{fontSize:'0.7rem',color:'#888',marginTop:'15px'}}>Voice will be transcribed to text and added to Notes tab automatically.</p>
    </div>
  );

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <style>{`@keyframes pulse { 0%{opacity:1} 100%{opacity:0.4} }`}</style>

      {/* Header */}
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>📔 My Diary — குறிப்பேடு</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Notes • To-Dos • Events • Voice • Share</div>
      </div>

      {/* Date nav */}
      <div style={{display:'flex',alignItems:'center',gap:'6px',justifyContent:'center',marginBottom:'8px'}}>
        <button onClick={prev} style={{border:'none',background:T.greenDk,color:'#fff',borderRadius:'6px',padding:'6px 12px',cursor:'pointer',fontSize:'1rem'}}>◀</button>
        <div style={{textAlign:'center',flex:1}}>
          <div style={{fontWeight:800,color:T.greenDk,fontSize:'0.9rem'}}>{dd}-{mm}-{date.getFullYear()} — {tDays[day]}</div>
          {pd && <div style={{fontSize:'0.7rem',color:T.maroon}}>{pd.YearNameInTamil} • {pd.TamilMonth}-{pd.TamilDate} • {pd.ThithiNameInTamil} • {pd.NakshatraNameInTamil}</div>}
          {pd?.DaySpecialityInTamil && <div style={{fontSize:'0.65rem',color:T.orange,fontWeight:600}}>⭐ {pd.DaySpecialityInTamil}</div>}
        </div>
        <button onClick={next} style={{border:'none',background:T.greenDk,color:'#fff',borderRadius:'6px',padding:'6px 12px',cursor:'pointer',fontSize:'1rem'}}>▶</button>
      </div>
      <div style={{display:'flex',gap:'6px',justifyContent:'center',marginBottom:'10px'}}>
        <button onClick={today} style={{border:'1px solid '+T.greenDk,background:'#fff',color:T.greenDk,borderRadius:'16px',padding:'3px 14px',fontSize:'0.7rem',cursor:'pointer',fontWeight:700}}>இன்று</button>
        <button onClick={()=>{const d=new Date();d.setDate(d.getDate()+1);setDate(d);}} style={{border:'1px solid '+T.greenDk,background:'#fff',color:T.greenDk,borderRadius:'16px',padding:'3px 14px',fontSize:'0.7rem',cursor:'pointer',fontWeight:700}}>நாளை</button>
      </div>

      {/* Rahu/Yama/Gulika */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'4px',marginBottom:'10px'}}>
        <div style={{background:'#ffebee',padding:'6px',borderRadius:'6px',textAlign:'center'}}>
          <div style={{fontSize:'0.6rem',fontWeight:700,color:'#c62828'}}>🔴 ராகு</div>
          <div style={{fontSize:'0.75rem',fontWeight:800,color:T.maroon}}>{rahuK[day]}</div>
        </div>
        <div style={{background:'#fff3e0',padding:'6px',borderRadius:'6px',textAlign:'center'}}>
          <div style={{fontSize:'0.6rem',fontWeight:700,color:T.orange}}>🟡 எமகண்டம்</div>
          <div style={{fontSize:'0.75rem',fontWeight:800,color:T.orange}}>{yamaK[day]}</div>
        </div>
        <div style={{background:'#e8f5e9',padding:'6px',borderRadius:'6px',textAlign:'center'}}>
          <div style={{fontSize:'0.6rem',fontWeight:700,color:T.greenDk}}>🟢 குளிகை</div>
          <div style={{fontSize:'0.75rem',fontWeight:800,color:T.greenDk}}>{gulK[day]}</div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',gap:'2px',overflowX:'auto',marginBottom:'10px',borderBottom:'2px solid '+T.greenDk,paddingBottom:'2px'}}>
        {TABS.map(t => (
          <button key={t.id} onClick={()=>setTab(t.id)} style={{
            flex:'1 0 auto',border:'none',padding:'6px 10px',borderRadius:'8px 8px 0 0',fontSize:'0.7rem',fontWeight:700,cursor:'pointer',
            background:tab===t.id?T.greenDk:'#fff',color:tab===t.id?'#fff':T.greenDk,whiteSpace:'nowrap'
          }}>{t.icon} {t.label}</button>
        ))}
      </div>

      {/* Tab Content */}
      <div style={{background:T.cream,borderRadius:'10px',padding:'12px',border:'1px solid '+T.border,minHeight:'200px'}}>
        {tab==='notes' && <NotesTab />}
        {tab==='todos' && <TodosTab />}
        {tab==='events' && <EventsTab />}
        {tab==='reminders' && <RemindersTab />}
        {tab==='voice' && <VoiceTab />}
      </div>

      {/* Share via WhatsApp */}
      <div style={{textAlign:'center',padding:'16px',borderTop:'1px solid '+T.border,marginTop:'12px'}}>
        <div style={{fontWeight:700,color:T.greenDk,fontSize:'0.8rem',marginBottom:'8px'}}>📤 Share this day's schedule</div>
        <button onClick={shareToFriends}
          style={{border:'none',background:'#25D366',color:'#fff',borderRadius:'25px',padding:'10px 24px',fontSize:'0.85rem',fontWeight:700,cursor:'pointer',boxShadow:'0 2px 8px rgba(37,211,102,0.3)'}}>
          📱 WhatsApp-ல் பகிர்
        </button>
        <div style={{fontSize:'0.6rem',color:'#888',marginTop:'6px'}}>Friends will receive your schedule. Your data helps us serve you better.</div>
      </div>

      {/* Save FAB */}
      <button onClick={()=>{save();alert('💾 சேமிக்கப்பட்டது!');}}
        style={{position:'fixed',bottom:'80px',right:'20px',width:'50px',height:'50px',borderRadius:'50%',border:'none',
          background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',fontSize:'1.3rem',cursor:'pointer',
          boxShadow:'0 4px 12px rgba(0,0,0,0.3)',zIndex:10}} title="சேமிக்க">💾</button>
    </div>
  );
};
export default DiaryPage;